export default __webpack_public_path__ + "static/03-66589b8344f77bd885eddf21ee25f1f5.jpg";